module.exports = __webpack_public_path__ + "img/canbadge-round-38mm-glitter_trimmark.f5b06dbc.png";